import { Paper, useTheme } from "@mui/material";

const StandardCardContainer = ({ children, minHeight = 600, minWidth = 600, elevation = 1 }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={elevation}
      sx={{
        minWidth: minWidth,
        minHeight: minHeight,
        border: 1,
        backgroundImage: "none",
        backgroundColor: theme.palette.background.default,
        borderColor: theme.palette.border.main,
        borderRadius: "10px",
        padding: 1,
        flex: 1,
      }}>
      {children}
    </Paper>
  );
};
export default StandardCardContainer;
